import { useEffect } from 'react';
import { useLazyQuery } from '@apollo/client';
import {
  GroupType,
  GetFinalPriceForProductsResponse,
  ProductFinalPrice,
} from 'graphql-query-contracts';

import { convertToUUID, isProbablyUUID } from 'uuid-encoding';
import { getFinalPriceForProductsQuery } from 'graphql-queries';
import { Payer } from '../types';
import { Channel } from '../../../types/ChannelType';

export function useFinalPriceQuery({
  productIds,
  payer,
  channel,
}: {
  productIds: Array<string>;
  payer: Payer;
  channel?: Channel;
}): { finalPriceList: Array<ProductFinalPrice> } {
  const [getFinalPriceForProductsLazyQuery, finalPriceForProductsResponse] =
    useLazyQuery<{
      getFinalPriceForProducts: GetFinalPriceForProductsResponse;
    }>(getFinalPriceForProductsQuery);

  useEffect(() => {
    if (
      channel &&
      payer.id &&
      productIds.length > 0 &&
      isProbablyUUID(productIds[0])
    ) {
      getFinalPriceForProductsLazyQuery({
        variables: {
          getFinalPriceForProductsRequest: {
            payer: {
              id: convertToUUID(payer.id),
              type: payer.type,
            },
            group: {
              id: convertToUUID(channel._id),
              type: GroupType.GroupTypeActivateChannel,
            },
            productIds,
          },
        },
      });
    }
  }, [channel?._id, payer.id, payer.type, JSON.stringify(productIds)]);

  return {
    finalPriceList:
      finalPriceForProductsResponse.data?.getFinalPriceForProducts
        .productFinalPrices ?? [],
  };
}
